import { FinixJobHealthSection } from "./FinixJobHealthSection";
import { FinixSettlementsSection } from "./FinixSettlementsSection";
import { FinixWebhooksSection } from "./FinixWebhooksSection";

// CLE-2949 — Finix operations: webhooks (with Retry), settlements per merchant and job health. Onboarding and
// compliance forms stay on the hospital edit page.
export function FinixTab() {
  return (
    <div className="flex flex-column gap-5">
      <section>
        <h2 className="mt-0 mb-3 text-xl">Webhooks</h2>
        <FinixWebhooksSection />
      </section>
      <section>
        <h2 className="mt-0 mb-3 text-xl">Settlements per merchant</h2>
        <FinixSettlementsSection />
      </section>
      <section>
        <h2 className="mt-0 mb-3 text-xl">Job health</h2>
        <FinixJobHealthSection />
      </section>
    </div>
  );
}
